export const NEXT_PUBLIC_SITE_URL = (process.env.NEXT_PUBLIC_SITE_URL as string) || 'https://evoorion.com';
export const MODE = (process.env.MODE as 'live' | 'preview') || 'live';
export const STORYBLOK_TOKEN = process.env.STORYBLOK_TOKEN as string;
export const STORYBLOK_VERSION = (process.env.STORYBLOK_VERSION as 'draft' | 'published') || 'draft';
export const NEXT_PUBLIC_GOOGLE_MAPS_API_KEY = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY as string;
export const NEXT_PUBLIC_HUBSPOT_API_KEY = process.env.NEXT_PUBLIC_HUBSPOT_API_KEY as string;
export const NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID as string;
export const POSTMARK_API_KEY = process.env.POSTMARK_API_KEY as string;
